// @flow
/**
 * Actions for the Instant Answers flow.
 *
 * Since in the main `actions.js` there are already 1200+ lines of code -
 * let's try to put new ones into the corresponding component directory or
 * split them somehow else.
 */

import { deepChange, goToModule } from "../../actions";
import { getGreetingMessage } from "./messaging";
import { getIAQueue, getModuleIdByBackendModuleType, iaGreetedUser } from "./selectors";

export const initIAstart = () => (dispatch: any, getState: any) => {
  const state = getState();
  if (!iaGreetedUser(state)) {
    dispatch(getGreetingMessage());
  }

  dispatch(deepChange({ "ia.wrongAnswersInRow": 0 }));
};

/**
 * Set the number of wrong IA answers.
 */
export const updateWrongAnswers = (value: number) => (dispatch: any) => {
  dispatch(deepChange({ "ia.wrongAnswersInRow": value }));
};

/**
 * Go to module by it's role. The mapping is passed from the backend.
 */
export const iaGoToModule = (backendModuleType: string) => (dispatch: any, getState: any) => {
  dispatch(goToModule(getModuleIdByBackendModuleType(backendModuleType, getState())));
};

/**
 * Set the flag representing it we had already show user the greeting IA messages.
 */
export const setGreetedUser = () => (dispatch: any, getState: any) => {
  if (!iaGreetedUser(getState())) {
    dispatch(deepChange({ "ia.hasGreeted": true }));
  }
};

/**
 * IA can take user back to regular chat flow to "ask question" part,
 * but to prevent the chat from asking "What is your question" again -
 * we store it here.
 */
export const saveLastIaQuestion = (text: string) => (dispatch: any) => {
  dispatch(deepChange({ "ia.lastQuestion": text }));
};

export const clearIAQueue = () => (dispatch: any, getState: any) => {
  const state = getState();
  const queue = getIAQueue(state);

  queue.forEach((queuedMessage) => clearTimeout(queuedMessage));
};
